import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { invokeApi } from '@/api/invoke/invokeApi'
import { PlumitifView } from '@/components/templates/PlumitifView'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'

const PlumitifComponent = () => {
  const { record } = Route.useRouteContext()
  const { text } = Route.useLoaderData()
  return <PlumitifView record={record} text={text} />
}

export const Route = createFileRoute('/judicial/$recordId/provincial/$soquijId')({
  component: withErrorBoundary(PlumitifComponent, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ params }) => {
    const text = await invokeApi<string, { recordId: string; soquijId: string }>('getProvincialRecord', params)
    return { text }
  },
  shouldReload: false,
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
